const Home = () => (
  <div className="home-container">
    <h1 className="display-4">Welcome to Math Magicians</h1>
    <p>
      Math Magicians is a simple calculator app that allows you to do basic math calculations.
      Mathemagician is a neologism, specifically a portmanteau, that combines mathematician
      and magician. A great number of self-working mentalism tricks rely on mathematical principles.
      Max Maven often utilizes this type of magic in his performance.
    </p>

    <p>
      Math Magicians can help you perform the following operations:
    </p>
    <ul>
      <li>Addition</li>
      <li>Subtraction</li>
      <li>Multiplication</li>
      <li>Division</li>
    </ul>
  </div>
);

export default Home;
